import React from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {getAplaClassNames} from "@pg-design/apla-module";
import {borderRadius, truncate, truncateMultiline} from "@pg-design/helpers-css";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";
import {formatDate} from "@pg-mono/string-utils";

import {useResponsiveLinkTarget} from "../../hooks/use_responsive_link_target";

interface IArticleGallery {
    image: {
        g_img_440x440: string;
        g_img_65x65: string;
        g_img_206x206: string;
        g_img_349x239: string;
    } | null;
}

interface IProps {
    article: {
        author: {
            name: string;
        };
        date_published: string | null;
        excerpt: string;
        gallery: IArticleGallery | (IArticleGallery | undefined)[] | null;
        id: number;
        slug: string;
        title: string;
    };
}

export const ArticleBox = ({article}: IProps) => {
    const link = rpAppLink.article.detail({articleId: article.id, articleSlug: article.slug});
    const src = Array.isArray(article.gallery) ? article.gallery[0]?.image?.g_img_440x440 : article.gallery?.image?.g_img_440x440;

    const target = useResponsiveLinkTarget();
    const articleBoxHandler = (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();
        window.open(link, "_blank");
    };

    return (
        <div css={articleBox} onClick={(e) => articleBoxHandler(e)}>
            <div>
                <div className={getAplaClassNames("dark")} css={overlay} />
            </div>

            <figure css={expandToParent}>
                <Image css={expandToParent} src={src} width="440px" height="440px" alt={article.title} ratio={{xs: "1/1"}} loading="lazy" />

                <figcaption css={[articleDetails]}>
                    <a href={link} css={articleLink} target={target}>
                        <TextWhite css={truncate} variant="headline_5" as="p" mb={2}>
                            {article.title}
                        </TextWhite>
                    </a>

                    <TextWhite css={truncateMultiline(4)} variant="info_txt_1">
                        {article.excerpt}
                    </TextWhite>

                    <div css={articleMeta}>
                        <TextWhite variant="body_copy_1">{formatDate(article.date_published)}</TextWhite>
                        <TextWhite variant="body_copy_1">{article.author.name}</TextWhite>
                    </div>
                </figcaption>
            </figure>
        </div>
    );
};

const articleBox = css`
    max-width: 36rem;
    width: 100%;
    overflow: hidden;
    position: relative;
    ${borderRadius()};
    &:hover {
        cursor: pointer;
    }
`;

const overlay = css`
    width: 100%;
    height: calc(100% - 2.4rem);
    position: absolute !important;
    bottom: 0;
`;

const expandToParent = css`
    width: 100%;
    height: 100%;
    margin: 0;
`;

const articleLink = css`
    display: block;

    &:hover,
    &:focus {
        color: inherit;
        text-decoration: none;
    }
`;

const articleDetails = css`
    position: absolute;
    width: 100%;
    bottom: 0;
    padding: 1.6rem 1.6rem 7.2rem;
    color: #fff;
    z-index: 2;
`;
const articleMeta = css`
    display: flex;
    justify-content: space-between;
    position: absolute;
    bottom: 1.6rem;
    width: calc(100% - 3.2rem);
`;

const TextWhite = styled(Text)`
    color: #fff;
`;
import React from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {getAplaClassNames} from "@pg-design/apla-module";
import {borderRadius, truncate, truncateMultiline} from "@pg-design/helpers-css";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";
import {formatDate} from "@pg-mono/string-utils";

import {useResponsiveLinkTarget} from "../../hooks/use_responsive_link_target";

interface IArticleGallery {
    image: {
        g_img_440x440: string;
        g_img_65x65: string;
        g_img_206x206: string;
        g_img_349x239: string;
    } | null;
}

interface IProps {
    article: {
        author: {
            name: string;
        };
        date_published: string | null;
        excerpt: string;
        gallery: IArticleGallery | (IArticleGallery | undefined)[] | null;
        id: number;
        slug: string;
        title: string;
    };
}

export const ArticleBox = ({article}: IProps) => {
    const link = rpAppLink.article.detail({articleId: article.id, articleSlug: article.slug});
    const src = Array.isArray(article.gallery) ? article.gallery[0]?.image?.g_img_440x440 : article.gallery?.image?.g_img_440x440;

    const target = useResponsiveLinkTarget();
    const articleBoxHandler = (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();
        window.open(link, "_blank");
    };

    return (
        <div css={articleBox} onClick={(e) => articleBoxHandler(e)}>
            <div>
                <div className={getAplaClassNames("dark")} css={overlay} />
            </div>

            <figure css={expandToParent}>
                <Image css={expandToParent} src={src} width="440px" height="440px" alt={article.title} ratio={{xs: "1/1"}} loading="lazy" />

                <figcaption css={[articleDetails]}>
                    <a href={link} css={articleLink} target={target}>
                        <TextWhite css={truncate} variant="headline_5" as="p" mb={2}>
                            {article.title}
                        </TextWhite>
                    </a>

                    <TextWhite css={truncateMultiline(4)} variant="info_txt_1">
                        {article.excerpt}
                    </TextWhite>

                    <div css={articleMeta}>
                        <TextWhite variant="body_copy_1">{formatDate(article.date_published)}</TextWhite>
                        <TextWhite variant="body_copy_1">{article.author.name}</TextWhite>
                    </div>
                </figcaption>
            </figure>
        </div>
    );
};

const articleBox = css`
    max-width: 36rem;
    width: 100%;
    overflow: hidden;
    position: relative;
    ${borderRadius()};
    &:hover {
        cursor: pointer;
    }
`;

const overlay = css`
    width: 100%;
    height: calc(100% - 2.4rem);
    position: absolute !important;
    bottom: 0;
`;

const expandToParent = css`
    width: 100%;
    height: 100%;
    margin: 0;
`;

const articleLink = css`
    display: block;

    &:hover,
    &:focus {
        color: inherit;
        text-decoration: none;
    }
`;

const articleDetails = css`
    position: absolute;
    width: 100%;
    bottom: 0;
    padding: 1.6rem 1.6rem 7.2rem;
    color: #fff;
    z-index: 2;
`;
const articleMeta = css`
    display: flex;
    justify-content: space-between;
    position: absolute;
    bottom: 1.6rem;
    width: calc(100% - 3.2rem);
`;

const TextWhite = styled(Text)`
    color: #fff;
`;
